import { ReactNode, useEffect } from 'react';
import { useCorePermissions } from '@/utils/apiRestCalls/core-permissions.api';
import { useCorePermissionsStore } from '@/stores/permissions.store';
import { PermissionKeyEnum } from '@/utils/types/Permission';
import { savePermissionsToStorage } from '@/utils/storage/permissions.storage';

type Props = {
  children: ReactNode;
};

export function CoreWrapper({ children }: Props) {
  const setCorePermissions = useCorePermissionsStore((state) => state.setCorePermissions);
  const { data: corePermissionsResponse, isFetched } = useCorePermissions();

  useEffect(() => {
    if (isFetched) {
      const corePermissions = corePermissionsResponse?.corePermissionStatus || [];
      setCorePermissions(corePermissions);
      savePermissionsToStorage(PermissionKeyEnum.Core, corePermissions);
    }
  }, [isFetched]);

  return <>{children}</>;
}
